export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  PATIENT = 'PATIENT',
  SOCIAL_WORKER = 'SOCIAL_WORKER',
  COMMUNITY_HEALTH_WORKER = 'COMMUNITY_HEALTH_WORKER',
  COMMUNITY_OUTREACH_SPECIALIST = 'COMMUNITY_OUTREACH_SPECIALIST',
  NURSE_PRACTITIONER = 'NURSE_PRACTITIONER',
  GUIDE = 'GUIDE',
  /** Member Enrollment Specialist — engages new members during outreach; distinct from ongoing guide. */
  MEMBER_ENROLLMENT_SPECIALIST = 'MEMBER_ENROLLMENT_SPECIALIST',
  GUIDE_SUPERVISOR = 'GUIDE_SUPERVISOR',
  PROVIDER = 'PROVIDER',
  SYSTEM = 'SYSTEM',
  CARE_TEAM_DIRECTOR = 'CARE_TEAM_DIRECTOR',
  CARE_TEAM_ASSISTANT_DIRECTOR = 'CARE_TEAM_ASSISTANT_DIRECTOR',
}

export const patientRoles = [UserRole.PATIENT];
export const careProviderRoles = [
  UserRole.ADMIN,
  UserRole.SUPER_ADMIN,
  UserRole.SOCIAL_WORKER,
  UserRole.COMMUNITY_HEALTH_WORKER,
  UserRole.COMMUNITY_OUTREACH_SPECIALIST,
  UserRole.NURSE_PRACTITIONER,
  UserRole.GUIDE,
  UserRole.MEMBER_ENROLLMENT_SPECIALIST,
  UserRole.GUIDE_SUPERVISOR,
  UserRole.PROVIDER,
  UserRole.CARE_TEAM_DIRECTOR,
  UserRole.CARE_TEAM_ASSISTANT_DIRECTOR,
];
export const assignableRoles = [
  UserRole.GUIDE,
  UserRole.MEMBER_ENROLLMENT_SPECIALIST,
  UserRole.GUIDE_SUPERVISOR,
  UserRole.PROVIDER,
  UserRole.COMMUNITY_OUTREACH_SPECIALIST,
];

// utils
export const userIsMember = (userObj: { role: UserRole }): boolean => {
  return patientRoles.includes(userObj.role);
};

export const userIsStaff = (userObj: { role: UserRole }): boolean => {
  return careProviderRoles.includes(userObj.role);
};
